<script lang="ts" setup>
interface SeenByProps {
  // Marks your latest message the other person has seen. Group read counts are not live;
  // groups use the "Who viewed this" message action.
  showSeenBy: boolean;
}

defineProps<SeenByProps>();

const emit = defineEmits(['showSeenByModal']);

function handleClickSeenBy() {
  emit('showSeenByModal');
}
</script>

<template>
  <span class="cursor-pointer flex" @click="() => handleClickSeenBy()">
    <span v-if="showSeenBy" class="mi md-16 mr-1 visibility" />
  </span>
</template>
